import { React } from 'react';
import styled, { keyframes } from 'styled-components';
import moment from 'moment';

import Image from '../../../Component/Share/Image';
import DefaultProfile from '../../../image/DefaultProfile.png';
import DefaultLogo from '../../../image/DefaultLogo.png';
import TicketWhite from '../../../image/TicketWhite.png';
import TicketGreen from '../../../image/TicketGreen.png';

export default function TicketSelectView(props) {
  const {
    memberInfo,
    usages,
    onClickTicket,
    calcMyReserve,
    calcMyRemainDate,
    calcMyRemainReserveCount,
  } = props;

  return (
    <TopLevelWrapper>
      {/* <TitleWrapper onClick={onClickLogo}>
        <LogoImage src='https://picture.link-zone.org/ZoneLogo.png' />
        <TitleText>Link Zone</TitleText>
      </TitleWrapper> */}
      <PartnerGymWrapper $isVisible={memberInfo.isPartnerGym}>
        <PartnerGymTextWrapper>
          <PartnerGymText>{'[' + memberInfo.storeName + '] PARTNER GYM'}</PartnerGymText>
        </PartnerGymTextWrapper>
        <StoreLogo src={memberInfo.storeLogo || DefaultLogo} />
      </PartnerGymWrapper>
      <MemberInfoWrapper>
        <ProfileWrapper >
          {/* <Profile src={memberInfo.profile === '' ? DefaultProfile : memberInfo.profile} /> */}
          <ProfileBox>
            <Image src={memberInfo.profile} defaultSrc={DefaultProfile} />
          </ProfileBox>
        </ProfileWrapper>
        <TextInfoWrapper>
          <InfoTotalWrapper>
            <MemberNameWrapper>
              <NameText fontFmaily='NotoSansKR-Bold' color='#000000'>{memberInfo.userName}</NameText>
              <NameText fontFmaily='NotoSansKR-Regular' color='#777777'>회원</NameText>
            </MemberNameWrapper>
            <TextColumnBoxWrapper>
              <TextColumnBox>
                <NameText fontFmaily='NotoSansKR-Regular' color='#CBCBCB'>성별</NameText>
              </TextColumnBox>
              <TextColumnBox>
                <NameText fontFmaily='NotoSansKR-Medium' color='#595959'>{memberInfo.gender === 'male' ? '남성' : '여성'}</NameText>
              </TextColumnBox>
            </TextColumnBoxWrapper>
            <TextColumnBoxWrapper>
              <TextColumnBox>
                {/* <NameText fontFmaily='NotoSansKR-Regular' color='#CBCBCB'>링크코치 아이디</NameText> */}
                <NameText fontFmaily='NotoSansKR-Regular' color='#CBCBCB'>링코 ID</NameText>
              </TextColumnBox>
              <TextColumnBox>
                <NameText fontFmaily='NotoSansKR-Medium' color='#595959'>{memberInfo.nickName}</NameText>
              </TextColumnBox>
            </TextColumnBoxWrapper>
            <TextColumnBoxWrapper>
              <TextColumnBox>
                <NameText fontFmaily='NotoSansKR-Regular' color='#CBCBCB'>락커 번호</NameText>
              </TextColumnBox>
              <TextColumnBox>
                <NameText fontFmaily='NotoSansKR-Medium' color='#595959'>{memberInfo.lockerName}</NameText>
              </TextColumnBox>
            </TextColumnBoxWrapper>
          </InfoTotalWrapper>
        </TextInfoWrapper>
      </MemberInfoWrapper>
      <InfoExplanationWrapper>
        <InfoExplanationText color='#6DD49E'>사용하실 회원권</InfoExplanationText>
        <InfoExplanationText color='#777777'>을 선택해주세요</InfoExplanationText>
      </InfoExplanationWrapper>
      <TicketTotalWrapper>
        {
          usages.map((data, index) => (
            <TicketWrapper key={index} onClick={() => onClickTicket(data)}>
              <TicketWhiteWrapper>
                <TicketImage src={TicketWhite} $isWhite />
                <TicketMemberShipInfoWrapper>
                  <TicketMemberShipInfoLayerWrapper>
                    <IndividualInfoWrapper>
                      <NameText fontFmaily='NotoSansKR-Regular' color='#BDBDBD'>회원권</NameText>
                    </IndividualInfoWrapper>
                    <IndividualInfoWrapper>
                      <NameText fontFmaily='NotoSansKR-Regular' color='#333333'>{data.memberShipName}</NameText>
                    </IndividualInfoWrapper>
                  </TicketMemberShipInfoLayerWrapper>
                  <TicketMemberShipInfoLayerWrapper>
                    <IndividualInfoWrapper>
                      <NameText fontFmaily='NotoSansKR-Regular' color='#BDBDBD'>예약 내역</NameText>
                    </IndividualInfoWrapper>
                    <IndividualInfoWrapper>
                      <NameText fontFmaily='NotoSansKR-Regular' color='#333333'>{calcMyReserve(data)}</NameText>
                    </IndividualInfoWrapper>
                  </TicketMemberShipInfoLayerWrapper>
                </TicketMemberShipInfoWrapper>
              </TicketWhiteWrapper>
              <TicketGreenWrapper>
                <TicketImage src={TicketGreen} />
                <TicketUsageWrapper>
                  <DdayText>{calcMyRemainDate(data)}</DdayText>
                  <RemainingText>{calcMyRemainReserveCount(data)}</RemainingText>
                  <DateText>{moment(data.startDate).format('YY.MM.DD') + ' - ' + moment(data.endDate).format('YY.MM.DD')}</DateText>
                </TicketUsageWrapper>
              </TicketGreenWrapper>
            </TicketWrapper>
          ))
        }
      </TicketTotalWrapper>
    </TopLevelWrapper>
  );
}

const startAnimation = keyframes`
  0% { opacity: 0; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  box-sizing: border-box;

  width: 100%;
  flex: 1;
  min-height: 0;

  padding: 0 6.5% 6.39%;

  animation-name: ${startAnimation};
  animation-duration: 0.5s;
  animation-timing-function: ease-out;
`;

const PartnerGymWrapper = styled.div`
  display: flex;
  flex-direction: row;

  visibility: ${props => props.$isVisible ? 'visible' : 'hidden'};

  justify-content: flex-start;
  // justify-content: center;
  align-items: center;

  width: calc(100% - 66px);
  height: 66px;

  margin-top: 1px;
  margin-left: 66px;

  @media (min-height: 320px) {
    height: 24px;
    width: calc(100% - 24px);
    margin-top: 12px;
    margin-left: 24px;
    border-radius: 6px;
  }
  @media (min-height: 640px) {
    height: 28px;
    width: calc(100% - 28px);
    margin-top: 12px;
    margin-left: 28px;
  }
  @media (min-height: 680px) {
    height: 30px;
    width: calc(100% - 30px);
    margin-top: 11px;
    margin-left: 30px;
    border-radius: 7px;
  }
  @media (min-height: 720px) {
    height: 32px;
    width: calc(100% - 32px);
    margin-top: 10px;
    margin-left: 32px;
  }
  @media (min-height: 800px) {
    height: 36px;
    width: calc(100% - 36px);
    margin-top: 14px;
    margin-left: 36px;
    border-radius: 8px;
  }
  @media (min-height: 1000px) {
    height: 50px;
    width: calc(100% - 50px);
    margin-top: 20px;
    margin-left: 50px;
    border-radius: 10px;
  }
  @media (min-height: 1200px) {
    height: 66px;
    width: calc(100% - 66px);
    margin-top: 21px;
    margin-left: 66px;
    border-radius: 15px;
  }

  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.10);
  // overflow: hidden;
`;

const StoreLogo = styled.img`
  // display: flex;
  // flex-direction: row;

  // justify-content: center;
  // align-items: center;

  width: 66px;
  // height: 100%;
  height: 66px;

  object-fit: contain;

  background-color: #FFFFFF;

  border-radius: 0 5px 5px 0;

  @media (min-height: 320px) {
    width: 24px;
    height: 24px;
  }
  @media (min-height: 640px) {
    width: 28px;
    height: 28px;
  }
  @media (min-height: 680px) {
    width: 30px;
    height: 30px;
  }
  @media (min-height: 720px) {
    width: 32px;
    height: 32px;
  }
  @media (min-height: 800px) {
    width: 36px;
    height: 36px;
  }
  @media (min-height: 1000px) {
    width: 50px;
    height: 50px;
  }
  @media (min-height: 1200px) {
    width: 66px;
    height: 66px;
  }
`;

const PartnerGymTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  // width: calc(100% - 66px);
  width: 100%;
  height: 66px;

  background-color: #FFA570;

  border-radius: 5px 0 0 5px;

  overflow: hidden;

  @media (min-height: 320px) {
    height: 24px;
  }
  @media (min-height: 640px) {
    height: 28px;
  }
  @media (min-height: 680px) {
    height: 30px;
  }
  @media (min-height: 720px) {
    height: 32px;
  }
  @media (min-height: 800px) {
    height: 36px;
  }
  @media (min-height: 1000px) {
    height: 50px;
  }
  @media (min-height: 1200px) {
    height: 66px;
  }
`;

const PartnerGymText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 25px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  max-width: 85%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media (min-height: 320px) {
    font-size: 12px;
  }
  @media (min-height: 640px) {
    font-size: 14px;
  }
  @media (min-height: 680px) {
    font-size: 14px;
  }
  @media (min-height: 720px) {
    font-size: 14px;
  }
  @media (min-height: 760px) {
    font-size: 14px;
  }
  @media (min-height: 800px) {
    font-size: 16px;
  }
  @media (min-height: 1000px) {
    font-size: 20px;
  }
  @media (min-height: 1200px) {
    font-size: 25px;
  }

  &:hover {
    cursor: default;
  }
`;

const MemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: stretch;

  // margin-top: 59px;
  margin-top: 24px;

  // width: 87.25%;
  width: 100%;
  // height: 15.47%;
`;

const ProfileWrapper = styled.div`
  position: relative;

  width: 32.8%;
  // padding-bottom: 32.8%;

   &::after {
    display: block;
    content: "";
    padding-bottom: 100%;
  }
`;

const ProfileBox = styled.div`
  position: absolute;

  width: 100%;
  height: 100%;

  border-radius: 10px;

  overflow: hidden;
`;

const TextInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 65.74%;
  height: 100%;

  background-color: #FFFFFF;

  border-radius: 10px;
  border: 1px solid #DFDFDF;
`;

const InfoTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: flex-start;

  width: 87%;
  height: 90%;

  @media (min-height: 320px) { padding: 8px 0px; }
  @media (min-height: 640px) { padding: 10px 0px; }
  @media (min-height: 720px) { padding: 12px 0px; }
  @media (min-height: 800px) { padding: 14px 0px; }
  @media (min-height: 1000px) { padding: 18px 0px; }
  @media (min-height: 1200px) { padding: 22px 0px; }
`;

const MemberNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 4px;

  overflow: hidden;

  & > p:first-child {
    width: auto;
    min-width: 0;
    flex-shrink: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & > p:last-child {
    width: auto;
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

const TextColumnBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  & > div:first-child {
    width: 5em;
    flex-shrink: 0;
  }

  & > div:last-child {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }
`;

const TextColumnBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 47.2%;

  overflow: hidden;
`;

const NameText = styled.p`
  font-family: ${props => props.fontFmaily};
  font-size: 13px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media (min-height: 320px) {
    font-size: 12px;
  }
  @media (min-height: 640px) {
    font-size: 13px;
  }
  @media (min-height: 720px) {
    font-size: 14px;
  }
  @media (min-height: 760px) {
    font-size: 15px;
  }
  @media (min-height: 800px) {
    font-size: 16px;
  }
  @media (min-height: 1000px) {
    font-size: 17px;
  }
  @media (min-height: 1200px) {
    font-size: 18px;
  }

  &:hover {
    cursor: default;
  }
`;

const InfoExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  // margin: 45px 0px 45px 0px;
  margin: 30px 0px 30px 0px;

  @media (min-height: 320px) {
    margin: 12px 0px 12px 0px;
  }
  @media (min-height: 800px) {
    margin: 20px 0px 20px 0px;
  }
  @media (min-height: 1200px) {
    margin: 30px 0px 30px 0px;
  }
`;

const InfoExplanationText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 18px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (min-height: 620px) {
    font-size: 18px;
  }
  @media (min-height: 720px) {
    font-size: 20px;
  }
  @media (min-height: 760px) {
    font-size: 22px;
  }
  @media (min-height: 800px) {
    font-size: 24px;
  }
  @media (min-height: 1000px) {
    font-size: 26px;
  }
  @media (min-height: 1200px) {
    font-size: 28px;
  }

  &:hover {
    cursor: default;
  }
`;

const TicketTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 66%;

  overflow-y: scroll;
  overflow-x: hidden;

  scrollbar-width: thin;
  scrollbar-color: #777777 transparent;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #777777;
    border-radius: 4px;
  }

  @media (min-height: 320px) { gap: 20px; padding-bottom: 20px; }
  @media (min-height: 760px) { gap: 25px; padding-bottom: 25px; }
  @media (min-height: 800px) { gap: 30px; padding-bottom: 30px; }
  @media (min-height: 880px) { gap: 35px; padding-bottom: 35px; }
  @media (min-height: 940px) { gap: 40px; padding-bottom: 40px; }
  @media (min-height: 1000px) { gap: 45px; padding-bottom: 45px; }
  @media (min-height: 1200px) { gap: 50px; padding-bottom: 50px; }
`;

const TicketWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 99%;
  flex-shrink: 0;

  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));

  @media (min-height: 320px) { height: 90px; }
  @media (min-height: 640px) { height: 110px; }
  @media (min-height: 720px) { height: 120px; }
  @media (min-height: 760px) { height: 130px; }
  @media (min-height: 800px) { height: 140px; }
  @media (min-height: 1000px) { height: 170px; }
  @media (min-height: 1200px) { height: 200px; }

  &:hover {
    cursor: pointer;
  }
`;

const TicketWhiteWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62.62%;
  height: 100%;
`;

const TicketGreenWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 37.38%;
  height: 100%;
`;

const TicketMemberShipInfoWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: flex-start;

  width: 82.91%;

  gap: 6px;

  @media (min-height: 320px) {
    gap: 8px;
  }
  @media (min-height: 640px) {
    gap: 10px;
  }
`;

const TicketMemberShipInfoLayerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 2px;

  @media (min-height: 320px) {
    gap: 4px;
  }
  @media (min-height: 640px) {
    gap: 6px;
  }
`;

const IndividualInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  overflow: hidden;

  @media (min-height: 320px) {
    height: 17px;
  }
  @media (min-height: 640px) {
    height: 19px;
  }
  @media (min-height: 720px) {
    height: 20px;
  }
  @media (min-height: 760px) {
    height: 21px;
  }
  @media (min-height: 800px) {
    height: 24px;
  }
  @media (min-height: 1000px) {
    height: 25px;
  }
  @media (min-height: 1200px) {
    height: 26px;
  }
`;

const TicketUsageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 85.87%;
`;

const TicketImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: ${props => props.$isWhite ? '10px 0 0 10px' : '0 10px 10px 0'};
`;

const DdayText = styled.p`
  font-family: Poppins-Bold;
  font-size: 24px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 24px;
  }
  @media (min-height: 640px) {
    font-size: 26px;
  }
  @media (min-height: 720px) {
    font-size: 28px;
  }
  @media (min-height: 760px) {
    font-size: 30px;
  }
  @media (min-height: 800px) {
    font-size: 32px;
  }
  @media (min-height: 1000px) {
    font-size: 30px;
  }
  @media (min-height: 1200px) {
    font-size: 36px;
  }

  &:hover {
    cursor: default;
  }
`;

const RemainingText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 12px;
  }
  @media (min-height: 640px) {
    font-size: 13px;
  }
  @media (min-height: 720px) {
    font-size: 15px;
  }
  @media (min-height: 760px) {
    font-size: 16px;
  }
  @media (min-height: 800px) {
    font-size: 17px;
  }
  @media (min-height: 1000px) {
    font-size: 19px;
  }
  @media (min-height: 1200px) {
    font-size: 21px;
  }

  &:hover {
    cursor: default;
  }
`;

const DateText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 10px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 10px;
  }
  @media (min-height: 640px) {
    font-size: 11px;
  }
  @media (min-height: 720px) {
    font-size: 12px;
  }
  @media (min-height: 760px) {
    font-size: 12px;
  }
  @media (min-height: 800px) {
    font-size: 13px;
  }
  @media (min-height: 1000px) {
    font-size: 15px;
  }
  @media (min-height: 1200px) {
    font-size: 17px;
  }

  &:hover {
    cursor: default;
  }
`;
